import { Link } from "react-router-dom";
import { useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import Logo from "../assests/Logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Services", path: "/services" },
    { name: "Training", path: "/training" },
    { name: "Internship", path: "/internship" },
    { name: "Projects", path: "/projects" },
    { name: "Careers", path: "/careers" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <>
      {/* 🔥 Navbar */}
      <header className="fixed top-0 left-0 w-full bg-white/80 backdrop-blur-md shadow-sm z-50 border-b">

        <div className="max-w-7xl mx-auto px-6 py-3 flex justify-between items-center">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img src={Logo} alt="logo" className="h-14" />
          </Link>

          {/* Desktop Menu */}
          <nav className="hidden md:flex gap-8 items-center text-gray-700 font-medium">

            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="hover:text-blue-600 transition"
              >
                {link.name}
              </Link>
            ))}

            {/* CTA Buttons */}
            <div className="flex gap-3 ml-4">

              <Link to="/internship">
                <button className="px-4 py-2 text-sm border border-blue-500 text-blue-600 rounded-lg hover:bg-blue-50 transition">
                  Join Internship
                </button>
              </Link>

              <Link to="/contact">
                <button className="px-5 py-2 text-sm bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg shadow hover:scale-105 transition">
                  Get Started
                </button>
              </Link>

            </div>

          </nav>

          {/* Mobile Icon */}
          <button
            className="md:hidden text-gray-800"
            onClick={() => setOpen(!open)}
          >
            {open ? <FiX size={26} /> : <FiMenu size={26} />}
          </button>

        </div>

        {/* 🔥 Mobile Menu */}
        <div
          className={`md:hidden bg-white border-t transition-all duration-300 ${
            open ? "max-h-[500px]" : "max-h-0 overflow-hidden"
          }`}
        >
          <div className="flex flex-col items-center gap-5 py-5 text-gray-700 font-medium">

            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                onClick={() => setOpen(false)}
              >
                {link.name}
              </Link>
            ))}

            {/* CTA Mobile */}
            <Link to="/internship" onClick={() => setOpen(false)}>
              <button className="px-5 py-2 border border-blue-500 text-blue-600 rounded-lg">
                Join Internship
              </button>
            </Link>

            <Link to="/contact" onClick={() => setOpen(false)}>
              <button className="px-5 py-2 bg-blue-600 text-white rounded-lg">
                Get Started
              </button>
            </Link>

          </div>
        </div>

      </header>

      {/* Spacer */}
      <div className="h-[70px]" />
    </>
  );
}